<div class="modal active">
  <div class="modal__container modal__container--sm">
    <div class="fields">
      <h2>Procedure Import Options</h2>
      <div class="close" (click)="cancelImport()"><img src="/assets/img/close-white.svg" alt="" /></div>
      <div class="fields__container">
        <form autocomplete="off"  name="ngImportCsvForm" #ngForm="ngForm" id="importCsvForm" class="active">
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4>File Format</h4>
                <span> </span>
              </div>
              <div class="table-fields">
                <div>
                  <table>
                    <caption>
                    </caption>
                    <thead>
                      <tr>
                        <th scope="col">Name</th>
                        <th scope="col">Index</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr mdbTableCol *ngFor="let el of procedureImportCSVModel.table; let i = index">
                        <td>{{ el.name }}</td>
                        <td>
                          <input id="index_{{i}}"
                          name="index_{{i}}"
                          [(ngModel)]="el.index" value="el.index"/>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

            </div>
          </div>
          <div class="fields__block">
            <div class="fields__block__section">
              <div class="title">
                <h4 style="opacity: 0;">title</h4>
                <span></span>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">Data Starting Line</label>
                  <input
                    style="max-width: 112px;"
                    maxlength="5"
                    [(ngModel)]="procedureImportCSVModel.dataStartingLine"
                    type="number"
                    name="dataStartingLine"
                    id="dataStartingLine"
                  />
                </div>
              </div>
              <div class="dropdown-fields">
                <div>
                  <label for="">Field Separator</label>
                  <select
                      name="fieldSeparator"
                      [(ngModel)]="procedureImportCSVModel.fieldSeparator"
                    >
                      <option value=".">Dot (.)</option>
                      <option value=",">Comma (,)</option>
                      <option value=";">Semicolon (;)</option>
                      <option value="\t">Tab</option>
                      <option value=" ">Space</option>
                    </select>
                </div>
              </div>
              <div class="dropdown-fields">
                <div>
                  <label for="">Decimal Separator</label>
                  <select
                      name="decimalSeparator"
                      [(ngModel)]="procedureImportCSVModel.decimalSeparator"
                    >
                      <option value=".">Dot (.)</option>
                      <option value=",">Comma (,)</option>
                      <option value=";">Semicolon (;)</option>
                    </select>
                </div>
              </div>
            </div>
            <div class="fields__block__section">
              <div class="title">
                <h4>CSV Source File</h4>
                <span> </span>
              </div>
              <div class="input-fields">
                <div>
                  <label for="">File</label>
                  <input
                  style="padding-left: 0px;"
                    maxlength="300"
                    type="file"
                    name="filename"
                    id="filename"
                    (change)="saveFile($event)"
                    [accept]="importFormat.fileExtension"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="fields__btn">
            <button type="submit" [ngClass]="ngForm.form.valid ? 'blue' : 'gray'" (click)="startImport();" [disabled]="!ngForm.form.valid">
              Import
            </button>
            <button class="gray" (click)="cancelImport()">Cancel</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>
